import { useLoaderData } from "react-router-dom";
import SuspenseVideoPlayer from "../../components/SuspenseVideoPlayer";
import { Profile } from "../../services/profile/profileModel";

const ProfileEmbedPage = () => {
  const { profile, video } = useLoaderData() as {
    profile: Profile;
    video: Promise<Blob>;
  };

  return (
    <div className="video-container --embed">
      <SuspenseVideoPlayer videoPromise={video} thumbnail={profile.thumbnail} />
    </div>
  );
};

export default ProfileEmbedPage;
